export default "__VITE_ASSET__CZr31tdN__"